module.exports = __webpack_public_path__ + "img/5.1c1cb486.png";